module.exports = __webpack_public_path__ + "static/media/hollow_bar_SMAP_tall.01c9b2cb.svg";